import {Controller} from "stimulus";

export default class extends Controller {

    connect() {
        super.connect();
        this.validetta();
    }

    initWeglot() {
        Weglot.initialize({
            api_key: atob(window.WEGLOT_API_KEY),
            cache: true,
            switchers: [
                {
                    style: {
                        is_dropdown: true,
                        with_flags: false,
                    }
                }
            ]
        });
    }

    validetta(){
        let controller = this;

        this.element.querySelectorAll('form input').forEach(function (element) {
            element.addEventListener("blur", function (){
                controller.initWeglot();
            });
        });

        // Bind only forms inside this controller. A page-wide $('form') selector
        // also hooked the wizard header Pause/Activate form, which has no
        // data-validetta fields — Validetta then crashes on submit (getAttribute).
        $(this.element).find('form:not(.no-validate)').validetta({
            showErrorMessages : true, // If you don't want to display error messages set this option false
            /** You can display errors as inline or bubble */
            display : 'bubble', // bubble or inline
            /**
             * Error template class
             * This is the class which will be added to the error message window template.
             * If you want special style, you can change class name as you like with this option.
             * Error message window template : <span class="errorTemplateClass">Error messages will be here !</span>
             */
            errorTemplateClass : 'validetta-bubble',
            /** Class that would be added on every failing validation field */
            errorClass : 'validetta-error',
            /** Same for valid validation */
            validClass : 'validetta-valid', // Same for valid validation
            bubblePosition: 'bottom', // Bubble position // right / bottom
            bubbleGapLeft: 15, // Right gap of bubble (px unit)
            bubbleGapTop: 9, // Top gap of bubble (px unit)
            /* To enable real-time form control, set this option true. */
            realTime : true,
            validators: {
                regExp: {
                    validName: {
                        pattern: /^[A-Za-z\s]+$/,
                        errorMessage: "Please enter a valid name with only alphabets."
                    },
                    validZip: {
                        pattern: /^[A-Za-z0-9][A-Za-z0-9\s-]{1,10}$/,
                        errorMessage: "Please enter a valid postcode / ZIP."
                    },
                    full_name: {
                        pattern : /^.{2,}\s.{2,}$/,
                        errorMessage : 'Full name appears to be invalid. It should contain both First and Last name (e.g. John Doe).'
                    },
                    special_charcters: {
                        pattern: /^([^0-9!@£#$%^&*(){}[\]:"|;'\<>?,.\/])$/,
                        errorMessage: 'Avoid using special charcters.'
                    },
                    company_name: {
                        pattern : /^.{2,}$/,
                        errorMessage : 'Company name should contain minimum 2 characters.'
                    },
                    password: {
                        pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@£#$%^&*(){}[\]:"|;'\<>?,.\/_\-+=])[A-Za-z\d!@£#$%^&*(){}[\]:"|;'\<>?,.\/_\-+=]{8,}$/,
                        errorMessage: ' Please enter a valid password.'
                    },
                    phone: {
                        pattern: /(?:\+?\d{1,3}\s*-?)?\(?(?:\d{3})?\)?[- ]?\d{3}[- ]?\d{4}/,
                        errorMessage: "You must enter a valid phone number"
                    },
                    email_address: {
                        pattern : /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        errorMessage : 'Your email address is invalid.'
                    },
                    single_name: {
                        pattern : /^([^0-9!@£$%^&*(){}[\]:"|;'\<>?,.\/]{2,})$/,
                        errorMessage : 'Enter your full name.'
                    },
                    phone_number: {
                        pattern : /(?:\d{1,3}\s*-?)?\(?(?:\d{3})?\)?[- ]?\d{3}[- ]?\d{4}/,
                        errorMessage : "Your phone number is invalid"
                    },
                    includehttps : {
                        pattern : /https:\/\//,
                        errorMessage : 'Web address must include https://'
                    },
                    includehttp : {
                        pattern : /http/,
                        errorMessage : 'Web address must include http:// or https://'
                    },
                    facebook : {
                        pattern : /https:\/\/.*facebook/,
                        errorMessage : 'You must enter a valid Facebook page address.'
                    },
                    twitter : {
                        pattern : /https:\/\/.*twitter/,
                        errorMessage : 'You must enter a valid Twitter page address.'
                    },
                    tripadvisor : {
                        pattern : /https:\/\/.*tripadvisor/,
                        errorMessage : 'You must enter a valid TripAdvisor page address.'
                    },
                    google : {
                        pattern : /^((?!http).)*$/,
                        errorMessage : 'Enter a Google search query, not a web address.'
                    },
                    yelp : {
                        pattern : /https:\/\/.*yelp/,
                        errorMessage : 'You must enter a valid Yelp page address.'
                    },
                    unifi : {
                        pattern : /https:\/\/.*(:\d*)/,
                        errorMessage : 'Your controller URL must start with https:// and end with a port. Typically 8443 or 443.'
                    },
                    instagram_embed : {
                        pattern : /instagram-media/,
                        errorMessage : 'You must enter valid Instagram embed code.'
                    }
                },
                remote: {
                    validate_calm: {
                        type: 'POST',
                        url: '/humans/validate/calm',
                        datatype: 'json'
                    },
                    validate_strict: {
                        type: 'POST',
                        url: '/humans/validate/strict',
                        datatype: 'json'
                    },
                    pass: {
                        type: 'POST',
                        url: 'https://yourhotspot.net/validate/password',
                        datatype: 'json'
                    }
                },
                callback: {
                    matchPassword: {
                        callback:  function( element, value ) {
                            let passwordElement = element.name.replace('_confirmation', '')
                            let password = element.form.querySelector(`input[name="${passwordElement}"]`).value;
                            return password === value
                        },
                        errorMessage: "Does not match Password."
                    }
                }
            },
            onError: function () {
                controller.initWeglot();
                let invalidFields = this.getInvalidFields();
                invalidFields.forEach(function ({field, errors}) {
                    field.addEventListener("blur", function (){
                        controller.initWeglot();
                    });
                    field.addEventListener("input", function (){
                        controller.initWeglot();
                    });
                })
            }
        });
    }
}
